import React from "react";

function GuideInfoBlock({ title, icon: Icon, children }) {
    if (!children) return null;

    return (
        <section className="min-w-0 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
            <div className="mb-3 flex min-w-0 items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600">
                    <Icon size={18} aria-hidden="true" />
                </span>
                <h3 className="min-w-0 text-base font-bold text-slate-900">
                    {title}
                </h3>
            </div>
            {children}
        </section>
    );
}

export default GuideInfoBlock;
